import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import TorontoFooter from '../Layout/TorontoFooter';
import './videos.css';
import BlackTop from './BlackTop';
import MiddleColumn from './MiddleColumn';
import { cityCodeGenerator } from './utils';
import SFFooter from '../Layout/SFFooter';
import OttawaFooter from '../Layout/OttawaFooter';
import LAFooter from '../Layout/LAFooter';
import NYCFooter from '../Layout/NYCFooter';

const AutzuVideo = ({ country, state, city }) => {
  const cityCode = cityCodeGenerator(country, state, city);
  return (
    <Fragment>
      <Helmet>
        <title>Autzu Videos</title>
        <meta name="description" />
      </Helmet>
      <div className="careersPage container">
        <BlackTop />
        <MiddleColumn cityCode={cityCode} />
        {cityCode === 'tor' ? (
          <TorontoFooter />
        ) : cityCode === 'sf' ? (
          <SFFooter />
        ) : cityCode === 'ott' ? (
          <OttawaFooter />
        ) : cityCode === 'la' ? (
          <LAFooter />
        ) : cityCode === 'nyc' ? (
          <NYCFooter />
        ) : (
          <SFFooter />
        )}
      </div>
    </Fragment>
  );
};

export default AutzuVideo;



// WEBPACK FOOTER //
// ./src/components/Videos/index.js